export const OPERATOR_COMPONENT_MAP = {
  is: 'select',
  isNot: 'select',
  isEmpty: null,
  isNotEmpty: null,
  startsWith: 'text',
  endsWith: 'text',
  contains: 'text',
  notContains: 'text',
  includes: 'multiselect',
  notIncludes: 'multiselect',
  greaterThan: 'text',
  greaterThanOrEqual: 'text',
  lessThan: 'text',
  lessThanOrEqual: 'text',
  on: 'date_options_select',
  between: 'dual_date_picker',
  inNext: 'unit',
  inLast: 'unit',
  notInLast: 'unit',
  after: 'datepicker',
  before: 'datepicker'
};

/**
 * This will dynamically construct the map based on the selected field.
 * This will make the code readable and more understandable. Commenting this for now as this needs more testing.
 */

// const constructOperatorComponentMap = (field) => {
//   let constructedMap = { ...OPERATOR_COMPONENT_MAP };
//   if (field.dataType === 'datetime') {
//     constructedMap = {
//       ...constructedMap,
//       after: 'datetime_picker',
//       before: 'datetime_picker',
//       between: 'dual_datatime_picker'
//     };
//   }
//   if (field.dataType === 'boolean') {
//     constructedMap = {
//       ...constructedMap,
//       is: 'boolean_select'
//     };
//   }
//   if (field.autoComplete) {
//     constructedMap = {
//       ...constructedMap,
//       is: 'search_select',
//       isNot: 'search_select',
//       includes: 'multi_search_select',
//       notIncludes: 'multi_search_select'
//     };
//   }
//   return constructedMap;
// };
